"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SvgIcon_1 = __importDefault(require("@mui/material/SvgIcon"));
const react_1 = __importDefault(require("react"));
const BubbleChatIcon = (props) => (react_1.default.createElement(SvgIcon_1.default, { viewBox: "0 0 24 24", ...props },
    react_1.default.createElement("path", { d: "M12 .9C5.38.9 0 5.34 0 10.8a8.97 8.97 0 0 0 3.32 6.83l-2.4 4.8c-.22.43.23.88.65.68l6.44-2.99c1.27.37 2.62.56 3.99.56 6.61 0 12-4.44 12-9.88C24 5.34 18.6.9 12 .9z" })));
exports.default = BubbleChatIcon;
